import { Spinner } from '@nrg/design-system';
import { useTranslation } from 'react-i18next';

export interface LoadingShellProps {
  /**
   * Accessible label announced by screen readers while the app boots.
   * Defaults to the localized `loading` string from the `common` namespace.
   */
  label?: string;
}

/**
 * Full-viewport centered spinner shown while the app bootstraps — both during
 * Amplify auth configuration and while the authenticated session (`/api/me`)
 * resolves. Shared so the boot experience is identical across both gates.
 *
 * The inner `Spinner` already exposes `role="status"` with `label` as its
 * accessible name, so the wrapper deliberately adds no second status role.
 */
export default function LoadingShell({ label }: LoadingShellProps) {
  const { t } = useTranslation();
  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--nrg-color-bg)',
      }}
    >
      <Spinner size="lg" label={label ?? t('loading')} />
    </div>
  );
}
